import { TaxiSplashScreen } from "@pga/taxi-splashscreen";
import { Suspense } from "react";
import { PassengerRoutes } from "./handleRoutes/passenger/routes";
import { MPRoutes } from "./handleRoutes/routes";
// import marker
const Router = () => {
  return (
    <Suspense fallback={<TaxiSplashScreen />}>
      <MPRoutes />
      <PassengerRoutes />
    </Suspense>
  );
};

export default Router;
